export default [
  { key: 'Authenticate' },
  { key: 'Event' },
  { key: 'Customers' },
  { key: 'CheckInOut' },
  { key: 'CheckInOutPublic' },
  { key: 'Smtp' },
  { key: 'LuckyDraw' },
  { key: 'InfoPin' },
  { key: 'InfoPrizesLuckydraw' },
  { key: 'InfoEventPayment' },
  { key: 'GroupInvite' },
  { key: 'UserRegister' },
  { key: 'UserInvite' },
  { key: 'UserAttendWedding' },
  { key: 'Notification' },
  { key: 'Notifications' },
  { key: 'Account' },
  { key: 'NotificationClient' },
  { key: 'DynamicGroupCode' },
  { key: 'DynamicOption' },
  { key: 'Gallery' },
  { key: 'Home' },
  { key: 'InfoCoupon' },
  { key: 'FormRegisterPublic' },
  { key: 'Wedding' },
  { key: 'TemplateECard' },
  { key: 'Welcome' },
  { key: 'Trade' },
  { key: 'InfoEvent' },
  { key: 'InfoConfigRegister' },
  { key: 'MstTemplatePrint' },
  { key: 'MstGame' },
  { key: 'InfoUserGame' },
  { key: 'MstPromotion' },
  { key: 'FormRegisterPublic2' },
  { key: 'Public' },
  { key: 'ListTableWedding' },
  { key: 'ListBlessings' },
  { key: 'BlessingsWedding' },
  { key: 'ConfigDynamicRegister' },
  { key: 'TemplateEmail' },
  { key: 'DynamicFormRegister' },
  { key: 'DynamicFormRegisterIEC' },
  { key: 'Templates' },
  { key: 'Booth' },
  { key: 'Reward' },
  { key: 'RewardRedemption' },
  { key: 'Sconfig' }
];
